import React from "react";
import styles from "./resume.module.css";
import { AiOutlineCopy } from "react-icons/ai";
import { getLocal } from "../../utils/Local/local";
import MadeBy from "../../components/MadeBy/MadeBy";

const Resume = () => {
  let text = getLocal("resume_builder");

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copied";
  };

  const showCopyClipText = () => {
    var tooltip = document.getElementById("myTooltip");
    tooltip.innerHTML = "Copy to clipboard";
  };
  return (
    <>
      <div className={styles.resume__container}>
        <div className={styles.resume__box}>
          <div className={styles.congrats__box}>
            <h3 className={styles.congrats__text}>꧁⭑⭒ congratulations ⭑⭒꧂</h3>
            <p className={styles.congrats__success}>
              You data have been saved successfully
            </p>
          </div>

          <p className={styles.follow__text}>
            Follow the below instruction to get Resume
          </p>

          <div className={styles.inst__box}>
            <div className={styles.copy__box}>
              <p>Copy the text</p>
              <div>
                <input type="text" value={text} />
                <div className={styles.tooltip}>
                  <button onClick={handleCopy} onMouseOut={showCopyClipText}>
                    <span className={styles.tooltiptext} id="myTooltip">
                      Copy to clipboard
                    </span>
                    <AiOutlineCopy />
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.redirect__box}>
              <p>Visit below link and paste copied text</p>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://resume-builder-view.vercel.app/"
                className={styles.link__text}
              >
                Click here
              </a>
            </div>
          </div>
        </div>

        <MadeBy />
      </div>
    </>
  );
};

export default Resume;
